import { Injectable, signal } from '@angular/core';

import { MOBILE_QUERY } from '../../core/constants/breakpoints';

const STORAGE_KEY = 'sinergial.sidebar.collapsed';
const MOBILE_MEDIA_QUERY = MOBILE_QUERY;

const isMobileViewport = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia?.(MOBILE_MEDIA_QUERY).matches ?? false;
};

const readStoredValue = (): boolean => {
  if (typeof localStorage === 'undefined') {
    return false;
  }

  const value = localStorage.getItem(STORAGE_KEY);
  if (value === null) {
    return isMobileViewport();
  }

  return value === 'true';
};

@Injectable({ providedIn: 'root' })
export class SidebarStateService {
  private readonly collapsed = signal(readStoredValue());
  readonly isCollapsed = this.collapsed.asReadonly();

  toggle(): void {
    this.setCollapsed(!this.collapsed());
  }

  collapseIfMobile(): void {
    if (isMobileViewport()) {
      this.setCollapsed(true);
    }
  }

  setCollapsed(value: boolean): void {
    this.collapsed.set(value);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, String(value));
    }
  }
}
